import Contact from "../Contact/Contact";
import BusinessBanner from "./Business-Banner/BusinessBanner";
import BusinessFuture from "./Business-Future/BusinessFuture";
import BusinessStrategic from "./Business-Strategic/BusinessStrategic";
import Parte from "./Parte/Parte";
import Evaluate from "./Evaluate/Evaluate";

export default function BusinessPartner() {
  return (
    <div className="w-full">
      <BusinessBanner />
      <BusinessFuture/>
      <BusinessStrategic/>
      <Parte/>
      <Evaluate/>
      <Contact />
    </div>
  );
}
